import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  color?: string;
}

/**
 * Thin stroked caret — Figma 17769:5648, exported vector `M1 1L4.75 4.75L8.5 1`.
 *
 * Deliberately NOT `ChevronDown`/`ChevronUp` from `src/common/Chevron`: those render a solid
 * filled triangle, and the mapping card's design draws an outline caret. Rotate it with CSS to
 * point up.
 */
export const ChevronCaretSvg: React.FC<Props> = ({ color }) => {
  const colors = useTheme().colors;
  return (
    <svg width="10" height="6" viewBox="0 0 9.5 5.75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1L4.75 4.75L8.5 1"
        stroke={color || colors.textMuted}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
